import React, { useState, } from 'react';
import { connect } from 'react-redux';
import correctCircle from '../images/additionalDocument/correct-circle.svg'
import { CLAIM_TYPE } from '../utils/claim-type'

import iconClaim from '../images/step2/ic_claim.svg'
import iconQuotation from '../images/step2/ic_quotation.svg'
import iconIDCard from '../images/step2/ic_id_card.svg'
import iconPicOfDamage from '../images/step2/ic_pic_of_damage.svg'
import iconVehicleRegister from '../images/step2/ic_vehical_register.svg'
import iconIDCardAuthorized from '../images/step2/ic_id_card_authorized.svg'
import iconPowerOfAttorney from '../images/step2/ic_power_of_attorney.svg'
import iconAct from '../images/step2/ic_act.svg'
import iconInsurancePolicy from '../images/step2/ic_insurance_policy.svg'
import iconRecipet from '../images/step2/ic_reciept.svg'
import iconCarDump from '../images/step2/ic_car_dump.svg'
import iconDoc from '../images/step2/ic_doc.svg'
import iconIDCardParty from '../images/step2/ic_id_card_party.svg'
import iconRegistrationCertificate from '../images/step2/ic_registration_certificate.svg'

function AdditionalDocumentInfo(props) {
  const openUpload = props.openUpload
  const submitRequestDocuments = props.submitRequestDocuments
  
  const [ requestDocuments, setRequestDocuments ] = useState(props.request_documents?.data||[])
  const [ documents, setDocuments ] = useState(
    [
      {
        id : 1,
        name : "ใบเคลม",
        nameMobile : "ใบเคลม",
        description : "หรือ ต้นฉบับหลักฐานรับผิดชอบ\nความเสียหายรถประกัน",
        descriptionMobile : "หรือ ต้นฉบับหลักฐานรับ\nผิดชอบความเสียหายรถประกัน",
        icon : iconClaim,
        is_required : true,
        is_signatured : false
      },
      {
        id : 2,
        name : "ใบเสนอราคา",
        nameMobile : "ใบเสนอราคา",
        description : "หรือคุณสามารถใช้ใบเสร็จแทนได้",
        descriptionMobile : "หรือคุณสามารถใช้ใบเสร็จแทนได้",
        icon : iconQuotation,
        is_required : true,
        is_signatured : false
      },
      {
        id : 3,
        name : "รูปภาพความเสียหาย",
        nameMobile : "รูปภาพ\nความเสียหาย",
        description : "กรุณาแสดงภาพความเสียหาย\nรวมถึงส่วนที่เกี่ยวข้อง",
        descriptionMobile : "กรุณาแสดงภาพความ\nเสียหายรวมถึงส่วนที่เกี่ยวข้อง",
        icon : iconPicOfDamage,
        is_required : true,
        is_signatured : false
      },
      {
        id : 4,
        name : "สำเนาบัตรประชาชนคู่กรณี",
        nameMobile : "สำเนา\nบัตรประชาชนคู่กรณี",
        description : "",
        descriptionMobile : "",
        icon : iconIDCardParty,
        is_required : true,
        is_signatured : true
      },
      {
        id : 5,
        name : "สำเนาบัตรประชาชน\nผู้เอาประกันภัย",
        nameMobile : "สำเนาบัตรประชาชน\nผู้เอาประกันภัย",
        description : "",
        descriptionMobile : "",
        icon : iconIDCard,
        is_required : true,
        is_signatured : true
      },
      {
        id : 6,
        name : "หนังสือมอบอำนาจ",
        nameMobile : "หนังสือมอบอำนาจ",
        description : "พร้อมสำเนาบัตรประชาชน\nและติดอากรสแตมป์ 30 บาท",
        descriptionMobile : "พร้อมสำเนาบัตรประชาชน\nและติดอากรสแตมป์ 30 บาท",
        icon : iconPowerOfAttorney,
        is_required : true,
        is_signatured : false
      },
      {
        id : 7,
        name : "สำเนาบัตรประชาชน\nผู้มอบอำนาจ",
        nameMobile : "สำเนาบัตรประชาชน\nผู้มอบอำนาจ",
        description : "",
        descriptionMobile : "",
        icon : iconIDCardAuthorized,
        is_required : true,
        is_signatured : true
      },
      {
        id : 8,
        name : "สำเนาหนังสือรับรอง\nการจดทะเบียน",
        nameMobile : "สำเนาหนังสือรับรอง\nการจดทะเบียน",
        description : "พร้อมสำเนาบัตรประชาชนกรรมการ",
        descriptionMobile : "พร้อมสำเนาบัตรประชาชนกรรมการ",
        icon : iconRegistrationCertificate,
        is_required : true,
        is_signatured : true
      },
      {
        id : 9,
        name : "ต้นฉบับคู่มือจดทะเบียนรถ",
        nameMobile : "ต้นฉบับ\nคู่มือจดทะเบียนรถ",
        description : "หรือสำเนา และรายการจดทะเบียน\nเปลี่ยนแปลง และรายการต่อภาษีปีปัจจุบัน",
        descriptionMobile : "หรือสำเนา และรายการจดทะเบียน\nเปลี่ยนแปลง และรายการต่อภาษีปีปัจจุบัน",
        icon : iconVehicleRegister,
        is_required : false,
        is_signatured : true
      },
      {
        id : 10,
        name : "สำเนากรมธรรม์ พรบ.",
        nameMobile : "สำเนา\nกรมธรรม์ พรบ.",
        description : "",
        descriptionMobile : "",
        icon : iconAct,
        is_required : false,
        is_signatured : false
      },
      {
        id : 11,
        name : "สำเนากรมธรรม์ประกันภัย\nภาคสมัครใจ",
        nameMobile : "สำเนา\nกรมธรรม์ประกันภัย\nภาคสมัครใจ",
        description : "",
        descriptionMobile : "",
        icon : iconInsurancePolicy,
        is_required : false,
        is_signatured : false
      },
      {
        id : 12,
        name : "ต้นฉบับใบเสร็จรับเงิน",
        nameMobile : "ต้นฉบับ\nใบเสร็จรับเงิน",
        description : "หรือ บิลเงินสดค่ารถยก",
        descriptionMobile : "หรือ บิลเงินสดค่ารถยก",
        icon : iconRecipet,
        is_required : true,
        is_signatured : false
      },
      {
        id : 13,
        name : "ภาพถ่ายขณะยกรถ",
        nameMobile : "ภาพถ่าย\nขณะยกรถ",
        description : "กรุณาแสดงภาพขณะยกรถ\nรวมถึงส่วนที่เกี่ยวข้อง",
        descriptionMobile : "กรุณาแสดงภาพขณะยกรถ\nรวมถึงส่วนที่เกี่ยวข้อง",
        icon : iconCarDump,
        is_required : true,
        is_signatured : false
      },
      {
        id : 14,
        name : "เอกสารเรียกร้อง\nค่าขาดประโยชน์",
        nameMobile : "เอกสารเรียกร้อง\nค่าขาดประโยชน์",
        description : "",
        descriptionMobile : "",
        icon : iconDoc,
        is_required : true,
        is_signatured : false
      },
      {
        id : 15,
        name : "ใบเคลม",
        nameMobile : "ใบเคลม",
        description : "หรือ สำเนาหลักฐานรับผิดชอบ\nความเสียหายรถคู่กรณี",
        descriptionMobile : "หรือ สำเนาหลักฐานรับผิดชอบ\nความเสียหายรถคู่กรณี",
        icon : iconClaim,
        is_required : true,
        is_signatured : false
      },
      {
        id : 16,
        name : "ใบเคลม",
        nameMobile : "ใบเคลม",
        description : "หรือ ต้นฉบับหลักฐานรับผิดชอบ\nความเสียหายรถคู่กรณี",
        descriptionMobile : "หรือ ต้นฉบับหลักฐานรับผิดชอบ\nความเสียหายรถคู่กรณี",
        icon : iconClaim,
        is_required : true,
        is_signatured : false
      },
      {
        id : 17,
        name : "ใบเสนอราคา",
        nameMobile : "ใบเสนอราคา",
        description : "",
        descriptionMobile : "",
        icon : iconQuotation,
        is_required : true,
        is_signatured : false
      },
      {
        id : 18,
        name : "ต้นฉบับใบเสร็จค่ารถยก",
        nameMobile : "ต้นฉบับ\nใบเสร็จค่ารถยก",
        description : "หรือ บิลเงินสดค่ารถยก",
        descriptionMobile : "หรือ บิลเงินสดค่ารถยก",
        icon : iconRecipet,
        is_required : true,
        is_signatured : false
      },
      {
        id : 19,
        name : "ใบเสนอราคา",
        nameMobile : "ใบเสนอราคา",
        description : "ต้นฉบับใบเสร็จค่ารถยก หรือ\nบิลเงินสดค่ารถยก​",
        descriptionMobile : "ต้นฉบับใบเสร็จค่ารถยก หรือ\nบิลเงินสดค่ารถยก​",
        icon : iconQuotation,
        is_required : true,
        is_signatured : false
      },
      {
        id : 20,
        name : "ภาพถ่ายความเสียหาย",
        nameMobile : "ภาพถ่าย\nความเสียหาย",
        description : "กรุณาแสดงภาพความเสียหาย\nรวมถึงส่วนที่เกี่ยวข้อง",
        descriptionMobile : "กรุณาแสดงภาพความเสียหาย\nรวมถึงส่วนที่เกี่ยวข้อง",
        icon : iconPicOfDamage,
        is_required : true,
        is_signatured : false
      },
      {
        id : 21,
        name : "ใบเคลม",
        nameMobile : "ใบเคลม",
        description : "หรือ สำเนาหลักฐานรับผิดชอบ\nความเสียหายรถประกัน",
        descriptionMobile : "หรือ สำเนาหลักฐานรับผิดชอบ\nความเสียหายรถประกัน",
        icon : iconClaim,
        is_required : true,
        is_signatured : false
      },
      {
        id : 22,
        name : "เอกสารการคุมราคาค่าซ่อม",
        nameMobile : "เอกสารการคุมราคาค่าซ่อม",
        description : "",
        descriptionMobile : "",
        icon : iconClaim,
        is_required : false,
        is_signatured : false
      },
      {
        id : 23,
        name : "ต้นฉบับใบเสร็จรับเงินค่าซ่อม",
        nameMobile : "ต้นฉบับใบเสร็จรับเงินค่าซ่อม",
        description : "",
        descriptionMobile : "",
        icon : iconClaim,
        is_required : false,
        is_signatured : false
      },
      {
        id : 24,
        name : "ภาพถ่ายขณะซ่อม และ หลังซ่อม",
        nameMobile : "ภาพถ่ายขณะซ่อม และ หลังซ่อม",
        description : "",
        descriptionMobile : "",
        icon : iconClaim,
        is_required : false,
        is_signatured : false
      },
      {
        id : 25,
        name : "ซากอะไหล่ (กรณีมีการระบุให้คืนซาก)",
        nameMobile : "ซากอะไหล่ (กรณีมีการระบุให้คืนซาก)",
        description : "",
        descriptionMobile : "",
        icon : iconClaim,
        is_required : false,
        is_signatured : false
      },
      {
        id : 26,
        name : "ต้นฉบับใบเสร็จค่ารถยก / บิลเงินสดค่ารถยก",
        nameMobile : "ต้นฉบับใบเสร็จค่ารถยก / บิลเงินสดค่ารถยก",
        description : "",
        descriptionMobile : "",
        icon : iconClaim,
        is_required : false,
        is_signatured : false
      },
      {
        id : 27,
        name : "สำเนาบัตรประชาชนเจ้าของรถคู่กรณี",
        nameMobile : "สำเนาบัตรประชาชนเจ้าของรถคู่กรณี",
        description : "",
        descriptionMobile : "",
        icon : iconClaim,
        is_required : false,
        is_signatured : false
      },
      {
        id : 28,
        name : "สัญญาประนีประนอมยอมความและรับเงิน (เอกสารบริษัท)",
        nameMobile : "สัญญาประนีประนอมยอมความและรับเงิน (เอกสารบริษัท)",
        description : "",
        descriptionMobile : "",
        icon : iconClaim,
        is_required : false,
        is_signatured : false
      },
      {
        id : 29,
        name : "ใบเสร็จรับเงินค่าซ่อม (บริษัทฯ จะพิจารณาคุมราคาตามมาตรฐาน)",
        nameMobile : "ใบเสร็จรับเงินค่าซ่อม (บริษัทฯ จะพิจารณาคุมราคาตามมาตรฐาน)",
        description : "",
        descriptionMobile : "",
        icon : iconClaim,
        is_required : false,
        is_signatured : false
      },
      {
        id : 30,
        name : "สำเนาหน้าบัญชีธนาคารเจ้าของรถ",
        nameMobile : "สำเนาหน้าบัญชีธนาคารเจ้าของรถ",
        description : "",
        descriptionMobile : "",
        icon : iconClaim,
        is_required : false,
        is_signatured : false
      },
      {
        id : 31,
        name : "สำเนาหน้าบัญชีธนาคารผู้เอาประกันภัย",
        nameMobile : "สำเนาหน้าบัญชีธนาคารผู้เอาประกันภัย",
        description : "",
        descriptionMobile : "",
        icon : iconClaim,
        is_required : false,
        is_signatured : false
      },
      {
        id : 32,
        name : "เอกสารการคุมราคาค่ารถยก",
        nameMobile : "เอกสารการคุมราคาค่ารถยก",
        description : "",
        descriptionMobile : "",
        icon : iconClaim,
        is_required : false,
        is_signatured : false
      },
      {
        id : 33,
        name : "หน้าบัญชีธนาคารผู้เอาประกัน",
        nameMobile : "หน้าบัญชีธนาคารผู้เอาประกัน",
        description : "",
        descriptionMobile : "",
        icon : iconClaim,
        is_required : false,
        is_signatured : false
      },
      {
        id : 34,
        name : "ใบเสนอราคาการเจรจา",
        nameMobile : "ใบเสนอราคาการเจรจา",
        description : "",
        descriptionMobile : "",
        icon : iconClaim,
        is_required : false,
        is_signatured : false
      },
    ]
  )

  return (
    <div className=' flex-wrap w-full '>
          <div className="flex flex-wrap w-full justify-center p-0  ">

          <div className='flex flex-wrap w-full md:w-[1092px md:px-20 md:pb-20 md:pt-[40px] ' >

            <div className=" flex flex-wrap w-full px-4 py-6 md:pt-[48px] md:pb-12  md:px-0">

                <div className='flex w-full'>
                  <span className='w-full font-thonburi text-[16px] font-semibold leading-6'>ข้อมูลผู้เรียกร้องค่าสินไหม</span>
                </div>

                <div className='flex-wrap w-full w-1/2 mt-4'>
                  <span className='font-thonburi text-[14px] font-normal text-[#666] leading-5'>เลขรับแจ้ง</span>
                  <div className="flex-wrap w-full ">
                    <span className='text-black flex-wrap w-full font-thonburi text-[16px] font-normal leading-6 '>{props.notify_no}</span>
                  </div>
                </div>

                
                <div className='flex-wrap w-full w-1/2 mt-4'>
                  <span className='font-thonburi text-[14px] font-normal text-[#666] leading-5'>เลขที่รายการ</span>
                  <div className="flex-wrap w-full ">
                    <span className='text-black flex-wrap w-full font-thonburi text-[16px] font-normal leading-6 '>{props.contact_info.ref_no}</span>
                  </div>
                </div>

                <div className='flex-wrap w-full mt-4'>
                  <span className='font-thonburi text-[14px] font-normal text-[#666] leading-5'>ชื่อผู้ติดต่อ</span>
                  <div className="flex-wrap w-full ">
                    <span className='text-black flex-wrap w-full font-thonburi text-[16px] font-normal leading-6 '>{props.contact_info.name}</span>
                  </div>
                </div>

                <div className='flex-wrap w-full mt-4'>
                  <span className='font-thonburi text-[14px] font-normal text-[#666] leading-5'>ทะเบียนรถ</span>
                  <div className="flex-wrap w-full ">
                    <span className='text-black flex-wrap w-full font-thonburi text-[16px] font-normal leading-6 '>{props.contact_info.carLicense_display}</span>
                  </div>
                </div>

                <div className='flex-wrap w-full mt-4'>
                  <span className='font-thonburi text-[14px] font-normal text-[#666] leading-5'>ประเภทรถ</span>
                  <div className="flex-wrap w-full ">
                    <span className='text-black flex-wrap w-full font-thonburi text-[16px] font-normal leading-6 '>{props.lisence_info.sufferer_type === 0 ? 'รถประกัน':'รถคู่กรณี'}</span>
                  </div>
                </div>

                <div className='flex-wrap w-full mt-4'>
                  <span className='font-thonburi text-[14px] font-normal text-[#666] leading-5'>ประเภทการเคลม</span>
                  <div className="flex-wrap w-full ">
                    <span className='text-black flex-wrap w-full font-thonburi text-[16px] font-normal leading-6 '>{CLAIM_TYPE(props.claim_info.type, props.lisence_info.sufferer_type)}</span>
                  </div>
                </div>

            </div>

            <div className=" flex flex-wrap w-full h-[8px] bg-[#FAFAFA]">
            </div>

            <div className="flex flex-wrap w-full py-6 md:py-12 md:px-0 ">

              <div className='flex w-full'>
                <span className='w-full px-4  font-thonburi text-[16px] font-semibold leading-6'>รายการเอกสารที่ขอเพิ่มเติม</span>
              </div>
              {
                requestDocuments.map(function(item, index){
                  const dataDoc = documents.find((doc)=> doc.id == item.docType );
                    return (
                      <div className='flex w-full px-4 border-b-2 pb-[16px]'>
                        <div className='flex-wrap w-full w-[20px] mt-4'>
                          <span className='font-thonburi text-[14px] font-normal text-[#666] leading-5'>
                            <img src={correctCircle} alt="icon-upload" className={ (item.files.length > 0 ? 'correct-circle-check ':' ' ) + ' h-[20px] max-w-max w-[28px]'} />
                          </span>
                        </div>

                        <div className='flex-wrap w-full mt-4 ml-[16px] mr-[16px]'>
                          <span className='font-thonburi text-[16px] font-normal leading-[24px]'>{dataDoc?.name}</span>
                          <div className="flex-wrap w-full ml-1">
                            <span className='text-black flex-wrap w-full font-thonburi text-[16px] text-[#666] font-normal leading-[24px] '>{dataDoc?.descriptionMobile}</span>
                          </div>
                          <div className="flex-wrap w-full ">
                            {                                   
                              (dataDoc?.is_signatured === true )?
                                (item.id === 8 ) ?
                                  <span className='inline-block ml-2 w-[100px] h-[20px] bg-green-200 font-thonburi text-[12px] leading-[21px] font-normal text-green-500 rounded-2xl text-center'>พร้อมประทับตรา</span>
                                  :
                                  <span className='inline-block ml-2 w-[100px] h-[20px] bg-green-200 font-thonburi text-[12px] leading-[21px] font-normal text-green-500 rounded-2xl text-center'>เซ็นสําเนาถูกต้อง</span>
                                :
                                null
                            }
                            <span className='font-thonburi text-[14px] ml-2 font-normal leading-[21px] text-[#ADADAD]'>{item.files.length} ไฟล์</span>
                          </div>
                        </div>

                        <div className='flex-wrap w-full w-[60px] mt-4'>
                          {item.files.length > 0  ? 
                            <span onClick={()=>{openUpload(item, index)}} className='font-thonburi text-[16px] font-normal text-[#009640] leading-[24px]  cursor-pointer'>แก้ไข</span>
                            :
                            <span onClick={()=>{openUpload(item, index)}} className='font-thonburi text-[16px] font-normal text-[#009640] leading-[24px]  cursor-pointer'>อัพโหลด</span>
                          }
                        </div>
                      </div>
                    )
                  })
              }
              
            </div>

            <div className=" flex flex-wrap w-full h-[8px] bg-[#FAFAFA] mb-[80px]">
            </div>

            <div className='flex-wrap flex w-full mt-6 md:mt-20  md:h-80px md:justify-center  bg-white border-t-[0.5px] border-grey-500 fixed bottom-0 right-0'>
              <div className='flex flex-wrap w-full md:w-[1092px] md:justify-end '>
                <button 
                    data-testid='next-button'
                    onClick={()=>{submitRequestDocuments()}}
                    className={'w-full m-[16px] md:w-[160px] lg:px-4 text-base leading-6 h-[48px]  md:h-12 font-medium rounded-lg border-radius-other  bg-green-500 text-white'}>
                      ส่งเอกสาร
                </button>
              </div>
            </div>

          </div>

          </div>
    </div>
  )
}

const mapStateToProps = state => {
  return state
}

export default connect(mapStateToProps)(AdditionalDocumentInfo);